// extracted by mini-css-extract-plugin
var _1 = "Headline2-moduleheadline2__GL81Y";
var _2 = "Headline2-modulesecondary__UCyfo";
var _3 = "Headline2-moduleskeleton__LhkiO Skeleton-moduleSkeleton__Mlrfv";
export { _1 as "headline2", _2 as "secondary", _3 as "skeleton" }
